import { Col, Tooltip } from 'antd'
import React, { useEffect, useState } from 'react'
import { FaPencil, FaTrash } from 'react-icons/fa6'
import logo from '../../images/logo.png';
import ImageBox from '../ImageBox';
import { ServiceObject} from '../../store/Store';
import {  filterPrice} from '../Alert';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
interface MultipleSelectProps {
    selected: number[];
    setselected: (setvalue: number[]) => void;
    number: number;
    data:ServiceObject;
    setnumber: (setvalue: number) => void;
    deleteHome: (setvalue: number) => void;
    unActiveHome: (setvalue: number) => void;
  
  }
const CardClientHomeServiceMini: React.FC<MultipleSelectProps>=({data, selected, setselected,number, setnumber, deleteHome, unActiveHome})=>{
    
    const [selected_bol, setselected_bol]=useState(selected.filter(x=>x===data.id).length!==0)
    const {t}=useTranslation()

    const handleSelect=(id:number)=>{
        var a=selected
        a.push(id)
        setselected(a)
        setselected_bol(true)
        setnumber(number+1)
    }
    const handleunSelect=(id:number)=>{
        var a=selected
        var b=a.findIndex(x=>x===id)
        a.splice(b, 1)
        setselected(a)
        setselected_bol(false)
        setnumber(number+1)
    }
    useEffect(()=>{
      setselected_bol(selected.filter(x=>x===data.id).length!==0)
    }, [selected])
   
  return (
    <Col className='mini_card_col' lg={8} md={12} sm={24}>
        
        <div className='card card_mini'>
            {data.status===1?<div className='client_card_text active_text'/>:<div className='client_card_text denger_text'/>}
            
            {/* <div className="lenta_card">
                <h1>TOP</h1>
            </div> */}
            <div className='card_mini_img card_img'>
            <ImageBox  alt='image' src={data.image!=null && data.image.image!=null?data.image.image:logo} />
            </div>
            <div className='card_mini_text'>
                <div className='card_mini_text_head'>
                <h1>{data.name!=null?data.name:''}</h1>
                <div className='card_mini_price card_price'>
                    <p>{filterPrice(data.price_uzs)+t(t(" so'm"))} <b className='slash_b'>/</b> {filterPrice(data.price_usd)+" $"}</p>
                    
                    {/* <span>Aktiv boshlanish: 12-04-2024</span>
                    <span>Aktiv tugashi: 22-05-2024</span> */}
                    <span>{t("visit_number")}: {data.viewed!==null?data.viewed:0}</span>
                </div>
                </div>
                
            </div>
            <div className='card_btns'>
                <div className='card_btns_edit'>
                    <Link to={"/client/home/service/edit/"+data.id} className='edit_btn'><div><FaPencil /></div></Link>
                    <button className='delete_btn' onClick={()=>{deleteHome(data.id)}}><div><FaTrash /></div></button>
                </div>
                {data.status!==1?selected_bol?<Tooltip placement="bottom" title={t("delete_choose")}>
                <button  onClick={()=>{handleunSelect((data.id))}} className='no_active_btn btn_client'><div>{t("delete_choose")}</div></button>
                </Tooltip>:<Tooltip placement="bottom" title={t("choose_add")}>
                <button onClick={()=>{handleSelect((data.id))}} className='active_btn btn_client'><div>{t("choose_item")}</div></button>
                </Tooltip>: <Tooltip placement="bottom" title={t("alert_active")}>
                <button onClick={()=>unActiveHome(data.id)} className='no_active_btn btn_client'><div>{t("stop_active")}</div></button>
                </Tooltip>}
                
                
               
            </div>
        </div>
    </Col>
  )
}
export default CardClientHomeServiceMini